// extracted by css-extract-rspack-plugin
export default {"productDeatailBox":"productDeatailBox-KUfABz"};